"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
let ExportRenewedDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.multiExportChoose = "all";
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  multiExport() {
    return __async(this, null, function* () {
      try {
        this.dialogLoading = true;
        this.$message.success(
          this.$t(
            "exportreneweddialog.getting_the_download_link_starting_the_download_later"
          )
        );
        let downloadWin = window.open("", "_self");
        const response = yield API.get(
          `api://base.auth.pro/v1/virtual-desktops/renew/export/${this.multiExportChoose}`
        );
        if (response.data.url === null) {
          this.$message.error(
            this.$i18n.t("exportreneweddialog.empty_datas")
          );
          return;
        } else {
          fetch(response.data.url).then((response2) => response2.blob()).then((blob) => {
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = response.data.title;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
          });
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.dialogLoading = false;
        this.close();
      }
    });
  }
  open() {
    this.dialogLoading = false;
    this.multiExportChoose = "export_all";
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
};
ExportRenewedDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], ExportRenewedDialog);
export {
  ExportRenewedDialog as default
};
